<template>
  <base-modal :hide_footer="true">
    <p>
      {{ $t('notify.notification.not_enough_money.body') }}
      <strong v-if="file_name">{{ file_name }}</strong>
    </p>
    <i-progress :percent="percent" stroke-color="#2196f3" hide-info class="ui-progressbar" />
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';

  export default {
    components: { BaseModal },
    props: {
      file_name: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      preogress_interval: null,
      percent: 0
    }),
    created() {
      this.preogress_interval = setInterval(this.incrementPercent, 100);
    },
    beforeDestroy() {
      clearInterval(this.preogress_interval);
      this.preogress_interval = null;
    },
    destroyed() {
      clearInterval(this.preogress_interval);
      this.preogress_interval = null;
    },
    methods: {
      incrementPercent() {
        if (this.percent < 101) {
          this.percent += 2;
        } else {
          clearInterval(this.preogress_interval);
          this.$emit('success');
        }
      }
    }
  };
</script>

<style lang="scss"></style>
